/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';
import ImagePicker from 'shared/ui/components/form-components/pickers/ImagePicker.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';

import DesignPreview from './preview/DesignPreview.vue';

const ASSETS_MAPPING = {
    'banner': {
        field: 'banner',
        hasAsset: 'has_banner_asset'
    }
};

/**
 * @typedef {object} Asset
 * @property {string} assetName
 * @property {File} [file]
 */

// Mixins
import form from 'ui/components/registrations/form';

const __vue_script__ = {
    name: 'Design',

    components: {
        BaseInput,
        Checkbox,
        ColorPicker,
        DesignPreview,
        HorizontalDivider,
        ImagePicker
    },

    mixins: [form],

    props: {
        event: {
            type: Object,
            required: true
        },

        settings: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            banner: null,
            imagePickerExtensions: ['png', 'jpg', 'jpeg'],
        };
    },

    computed: {
        show_calendar: {
            /** @returns {boolean} */
            get: function() {
                return !this.innerValue.hide_calendar;
            },
            /** @param {boolean} active */
            set: function(active) {
                this.innerValue.hide_calendar = !active;
            }
        },
        show_date: {
            /** @returns {boolean} */
            get: function() {
                return !this.innerValue.hide_date_info;
            },
            /** @param {boolean} active */
            set: function(active) {
                this.innerValue.hide_date_info = !active;
            }
        },
        show_footer: {
            /** @returns {boolean} */
            get: function() {
                return this.innerValue.hide_footer === false;
            },
            /** @param {boolean} active */
            set: function(active) {
                this.setValue('hide_footer', !active);
            }
        }
    },

    watch: {
        innerValue: {
            immediate: true,
            deep: true,
            handler() {
                this.init();
            }
        }
    },

    methods: {
        init() {
            for (const assetType of Object.keys(ASSETS_MAPPING)) {
                const asset = ASSETS_MAPPING[assetType];
                if (asset && this.innerValue[asset.hasAsset]) {
                    const imagePath = this.$services.pax.getAssetPath(this.event._id, assetType);
                    if (!this.innerValue[asset.field] || !this[asset.field]) {
                        this.innerValue[asset.field] = this[asset.field] = [imagePath];
                    }
                }
            }
        },

        onImageInput() {
            if (this.banner !== this.innerValue.banner) {
                this.$emit('asset-changed', 'banner');
            }
            this.banner = this.innerValue.banner;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"design",attrs:{"tag":"form","autocomplete":"off"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('registration.configuration.design_section.heading')))]),_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"primary_color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{staticClass:"title-color",attrs:{"name":"primary_color","context":_vm.event._id,"label":_vm.$t('registration.configuration.design_section.primary_color')},model:{value:(_vm.innerValue.button_background_color),callback:function ($$v) {_vm.$set(_vm.innerValue, "button_background_color", $$v)},expression:"innerValue.button_background_color"}})]}}])}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"button_foreground_color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{staticClass:"title-color",attrs:{"name":"button_foreground_color","context":_vm.event._id,"label":_vm.$t('registration.configuration.design_section.text_color')},model:{value:(_vm.innerValue.button_foreground_color),callback:function ($$v) {_vm.$set(_vm.innerValue, "button_foreground_color", $$v)},expression:"innerValue.button_foreground_color"}})]}}])})],1),_c('horizontal-divider'),_c('div',{staticClass:"form-groups"},[_c('checkbox',{attrs:{"name":"show_calendar","hint-after-label":true,"label":_vm.$t('registration.configuration.design_section.show_calendar.label'),"hint":_vm.$t('registration.configuration.design_section.show_calendar.hint'),"topLabel":_vm.$t('registration.configuration.design_section.show_calendar.top_label')},model:{value:(_vm.show_calendar),callback:function ($$v) {_vm.show_calendar=$$v},expression:"show_calendar"}}),_c('checkbox',{attrs:{"name":"show_date","hint-after-label":true,"label":_vm.$t('registration.configuration.design_section.show_date.label'),"hint":_vm.$t('registration.configuration.design_section.show_date.hint'),"top-label":_vm.$t('registration.configuration.design_section.show_date.top_label')},model:{value:(_vm.show_date),callback:function ($$v) {_vm.show_date=$$v},expression:"show_date"}})],1),_c('horizontal-divider'),_c('div',{staticClass:"form-groups"},[_c('image-picker',{staticClass:"banner-picker",attrs:{"label":_vm.$t('registration.configuration.design_section.banner.label'),"hint":_vm.$t('registration.configuration.design_section.banner.hint'),"name":"banner","extensions":_vm.imagePickerExtensions,"multiple":false,"width":2880,"height":692,"ratio":2880 / 692},on:{"input":_vm.onImageInput},model:{value:(_vm.innerValue.banner),callback:function ($$v) {_vm.$set(_vm.innerValue, "banner", $$v)},expression:"innerValue.banner"}}),_c('div',{staticClass:"form-group"},[_c('checkbox',{attrs:{"name":"show_footer","hint-after-label":true,"label":_vm.$t('registration.configuration.design_section.footer.opt_label'),"top-label":_vm.$t('registration.configuration.design_section.footer.label'),"hint":_vm.$t('registration.configuration.design_section.footer.tip')},model:{value:(_vm.show_footer),callback:function ($$v) {_vm.show_footer=$$v},expression:"show_footer"}}),(_vm.show_footer)?_c('base-input',{attrs:{"type":"text","placeholder":_vm.$t('registration.configuration.design_section.footer.text_placeholder'),"name":"footer_text","maxlength":160},model:{value:(_vm.innerValue.footer_text),callback:function ($$v) {_vm.$set(_vm.innerValue, "footer_text", $$v)},expression:"innerValue.footer_text"}}):_vm._e()],1)],1),_c('design-preview',{attrs:{"button-background-color":_vm.innerValue.button_background_color,"button-foreground-color":_vm.innerValue.button_foreground_color,"hide-calendar":_vm.innerValue.hide_calendar,"hide-date-info":_vm.innerValue.hide_date_info,"banner":_vm.banner,"hide-footer":_vm.innerValue.hide_footer,"footer-text":_vm.innerValue.footer_text,"event":_vm.event,"settings":_vm.settings}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Design.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__